import { templateService, type Template } from '@/services/templateService';
import { toFullImageUrl } from '@/utils/imageUrl';
import { useCanvasLibraryPage } from './useCanvasLibraryPage';

export interface CanvasTemplate {
  id: number;
  name: string;
  // Thumbnail, used by the list.
  url: string;
  // Full-size image, used when the template is dragged into the canvas.
  fullUrl: string;
}

const toCanvasTemplate = ({ id, data }: Template): CanvasTemplate => ({
  id,
  name: data.name,
  url: data.image,
  fullUrl: toFullImageUrl(data.image),
});

export const useCanvasTemplates = (search: string) => {
  const { items, ...page } = useCanvasLibraryPage({
    search,
    fetchPage: templateService.getTemplates,
    toItem: toCanvasTemplate,
    errorMessage: 'Error al obtener los templates',
  });
  return { templates: items, ...page };
};
